<template>
  <div class="column p0">
    <div
      class="column columns component_card_border_bottom main_red_bg"
      v-if="cancelOrder"
    >
      <h1 class="component_title_md fat">{{ $t("msg.canceling_order") }}</h1>
    </div>

    <div
      v-else-if="doneOrder"
      class="column columns component_card_border_bottom main_lgreen_bg"
    >
      <h1 class="component_title_md fat">
        {{ $t("msg.success") }}
      </h1>
    </div>

    <div
      v-else
      class="column columns component_card_border_bottom main_yellow_bg"
    >
      <h1 class="component_title_md fat main_blue_dk_fill">
        {{ $t("msg.purchase_confirmation") }}
      </h1>
    </div>

    <div class="column p0">
      <div class="column tal_c fs_big grey_ntx" v-if="!this.trade.sellerId">
        {{ $t("msg.send_exactly") }}
      </div>
      <div class="column tal_c fs_big grey_ntx" v-else>
        {{ $t("msg.otc_purchase_info_to_user") }}
      </div>

      <div
        class="column tal_c"
        v-if="trade.sourceCurrency && !this.trade.sellerId"
      >
        <p
          class="info_address fs_10r fat"
          style="color: #61717e"
          v-if="cancelOrder"
        >
          {{
            currencyFormat(trade.estimatedAmount, trade.sourceCurrency.symbol)
          }}
          {{ trade.sourceCurrency.symbol }}
        </p>

        <p class="info_address fs_10r fat" v-else>
          {{
            currencyFormat(trade.estimatedAmount, trade.sourceCurrency.symbol)
          }}
          {{ trade.sourceCurrency.symbol }}
        </p>
      </div>

      <div v-if="!this.trade.sellerId">
        <div class="column p0">
          <div class="column p0">
            <div class="combo_1">
              <div class="column tal_c">
                <div class="column p0 flex_contant_center">
                  <div v-if="this.isMobile">
                    <span
                      class="fs_0001r"
                      style="font-weight: 600"
                      v-if="trade.sourceCurrency.symbol == 'USDT'"
                      >Network: TRON (TRC20)</span
                    >
                    <div
                      v-if="!cancelOrder"
                      style="
                        border: solid #61717e 3px;
                        width: 100%;
                        heigth: 100%;
                        border-radius: 10px;
                      "
                      class="pointer"
                      v-clipboard:copy="purchaseHome.targetAddress"
                      v-clipboard:success="onCopySuccess"
                      v-clipboard:error="onCopyError"
                    >
                      <div style="height: 35%">
                        <span class="fs_00r">{{ $t("msg.copy_address") }}</span>
                      </div>
                      <div
                        style="
                          height: 65%;
                          display: flex;
                          justify-content: center;
                          word-break: break-all;
                          align-items: center;
                        "
                      >
                        <span class="fs_03r" v-if="purchaseHome">
                          {{ purchaseHome.targetAddress }}
                        </span>
                        <!-- <span class="fs_03r">
                          {{ trade.targetAddress }}
                        </span> -->
                      </div>
                    </div>
                  </div>
                  <div v-else class="w90">
                    <div style="text-align: left">
                      <span class="fs_0001r">{{ $t("msg.clicl_expand") }}</span>

                      <span
                        class="fs_0001r"
                        style="margin-left: 20px; font-weight: 600"
                        v-if="trade.sourceCurrency.symbol == 'USDT'"
                        >Network: TRON (TRC20)</span
                      >
                    </div>
                    <div
                      class="justify_content_between"
                      :style="qrCodeDiv ? 'opacity:0' : 'opacity:1'"
                    >
                      <div
                        style="
                          border: solid #61717e 3px;
                          width: 17%;
                          heigth: 100%;
                          border-radius: 10px;
                        "
                        class="pointer"
                        @click="qrCodeZoom()"
                      >
                        <span class="fs_00r">Scan or</span>
                        <qrcode
                          :style="cancelOrder ? 'opacity: 0' : 'opacity: 1;'"
                          :value="purchaseHome.targetAddress"
                          :options="{ width: 50 }"
                        ></qrcode>
                      </div>
                      <div
                        v-if="!cancelOrder"
                        style="
                          border: solid #61717e 3px;
                          width: 80%;
                          heigth: 100%;
                          border-radius: 10px;
                        "
                        class="pointer"
                        v-clipboard:copy="purchaseHome.targetAddress"
                        v-clipboard:success="onCopySuccess"
                        v-clipboard:error="onCopyError"
                      >
                        <div style="height: 35%">
                          <span class="fs_00r">{{
                            $t("msg.copy_address")
                          }}</span>
                        </div>
                        <div
                          style="
                            height: 65%;
                            display: flex;
                            justify-content: center;
                            word-break: break-all;
                            align-items: center;
                          "
                        >
                          <span class="fs_03r">
                            {{ purchaseHome.targetAddress }}
                          </span>
                          <!-- <div
                      class="icon_class_1"
                      v-html="iconSets.copy"
                      style="

                        margin-right: -63px;
                        background: #fcfcfc;
                        width: 25px;
                        height: 30px;
                        padding: 3px;
                      "
                    ></div> -->
                        </div>
                      </div>

                      <div
                        v-else
                        style="
                          border: solid #61717e 3px;
                          width: 80%;
                          heigth: 100%;
                          border-radius: 10px;
                        "
                      >
                        <div style="height: 25%">
                          <span class="fs_00r">{{
                            $t("msg.copy_address")
                          }}</span>
                        </div>
                        <div
                          style="
                            height: 75%;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            word-break: break-all;
                          "
                        >
                          --- Address unavailable ---
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="column">
      <hr style="background: #d8d6d6" />
    </div>

    <div
      style="display: flex; justify-content: center; z-index: 10 !important"
      v-if="qrCodeDiv"
    >
      <div
        class="qr-code effect1"
        style="
          background: #FFFFFF;
          width: 85%;
          height:400px
          box-shadow: 0px 12px 40px #0000004B;
          border-radius: 16px;
          margin-top:-180px;
          margin-bottom:30px;
          display: flex !important; 
          flex-direction:column;
          justify-content:center;
          align-items: center;
          z-index:10
        "
      >
        <div style="width: 80%; display: flex; justify-content: flex-end">
          <a class="pointer" @click="qrCodeZoom()"> X </a>
        </div>
        <div
          style="
            border: solid #61717e 5px;
            width: 70%;
            height: 80%;
            border-radius: 20px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          "
        >
          <span class="fs_00r fs_18r">Scan the QR code</span>
          <qrcode
            :style="cancelOrder ? 'opacity: 0' : 'opacity: 1;'"
            :value="purchaseHome.targetAddress"
            :options="{ width: 250 }"
          ></qrcode>
        </div>
      </div>
    </div>

    <div class="column tal_c" v-if="!qrCodeDiv">
      <p v-if="cancelOrder">{{ $t("msg.canceling_order") }}</p>
      <p v-else-if="doneOrder">{{ $t("msg.deposit_received") }}</p>
      <div v-else>
        <div
          class="transaction_loading status_border"
          v-if="!this.trade.sellerId"
        >
          <span v-html="iconSets.loading"></span>
          <p v-if="usdtPurchase">{{ $t("msg.generating_tokens") }}...</p>
          <p v-else>{{ $t("msg.waiting_deposit") }}...</p>
        </div>
        <div class="transaction_loading status_border" v-else>
          <span v-html="iconSets.loading"></span>
          <p style="margin-top: 20px">{{ $t("msg.waiting_deposit_otc") }}...</p>
        </div>
      </div>
    </div>

    <div
      class="column"
      style="display: flex; justify-content: center"
      v-if="!qrCodeDiv && !this.trade.sellerId"
    >
      <Progress
        v-if="cancelOrder"
        :transitionDuration="0"
        :radius="65"
        :strokeWidth="13"
        :value="100"
        strokeColor="#EE4F50"
      >
        <div class="content" style="color: #61717e">
          <span>{{ $t("msg.canceling") }}</span>
        </div>
      </Progress>

      <Progress
        v-else-if="doneOrder"
        :transitionDuration="0"
        :radius="65"
        :strokeWidth="13"
        :value="100"
        strokeColor="#3A8CEA"
      >
        <div class="content" style="color: #61717e">
          <span>{{ $t("msg.done") }}</span>
        </div>
      </Progress>

      <Progress
        v-else
        :transitionDuration="1000"
        :radius="65"
        :strokeWidth="14"
        :value="resultPercent"
        strokeColor="#4B5588"
      >
        <div class="content" style="color: #61717e">
          <span v-if="timer.days > 0"
            >{{ timer.days }} {{ $t("msg.days") }}</span
          ><br v-if="timer.days > 0" />
          <span>{{ getHours(timer.minutes) }}</span>
        </div>
      </Progress>
    </div>

    <div class="column tal_c" v-if="!this.trade.sellerId">
      <div
        style="background: #ff5050; color: white; padding: 10px"
        v-if="cancelOrder"
      >
        <p>{{ $t("msg.attention_cancel") }}!</p>
      </div>

      <div
        style="background: #3a8cea; color: white; padding: 10px"
        v-else-if="doneOrder"
      >
        <p>{{ $t("msg.attention_done") }}!</p>
      </div>

      <div style="background: #e3a00a; color: black; padding: 10px" v-else>
        <p
          v-html="
            $t('msg.attention_waiting_days', {
              hours: getHours(complete.minutes),
            })
          "
        ></p>
      </div>
    </div>

    <div class="column tal_c m10_t" v-if="!this.trade.sellerId">
      <div
        style="display: flex; justify-content: center; align-items: center"
        class="pointer"
        @click="details = !details"
      >
        <p class="capitalize" style="display: flex; align-items: center">
          {{ $t("msg.transaction_details") }}
          <span
            v-html="iconSets.general_arrow_down"
            class="icon_class_1"
            :style="details == true ? 'transform: rotate(180deg)' : ''"
          ></span>
        </p>
      </div>
    </div>

    <div class="column" v-if="details && trade.sourceCurrency.symbol">
      <div class="landing_buy_blu_transaction_details_inner">
        <div class="column p0 split_half_text">
          <p id="amount_before_fees_" class="tal_r_b">
            <span class="tal_l">{{ $t("msg.status") }}:</span>
            <span class="capitalize">{{ trade.status }}</span>
          </p>
        </div>

        <div class="column p0 split_half_text">
          <p id="amount_before_fees_" class="tal_r_b">
            <span class="tal_l" v-if="trade.status == 'done'"
              >{{ $t("msg.received") }} {{ trade.sourceCurrency.symbol }}:</span
            >
            <span class="tal_l" v-else
              >{{ $t("msg.expected_amount_in") }}
              {{ trade.sourceCurrency.symbol }}:</span
            >
            <span
              >{{
                currencyFormat(
                  trade.estimatedAmount,
                  trade.sourceCurrency.symbol
                )
              }}
              {{ trade.sourceCurrency.symbol }}</span
            >
          </p>
        </div>
        <!-- {{feePurchase}} -->
        <div
          class="column p0 split_half_text"
          v-if="trade.sourceCurrency.symbol != 'BRL'"
        >
          <p id="amount_before_fees_" class="tal_r_b">
            <span class="tal_l">{{ $t("msg.estimated_amount_in") }} BLUE:</span>
            <span>{{ getEstimatedAmount() }} BLUE</span>
          </p>
        </div>
      </div>
    </div>

    <!-- v-clipboard:success="onCopySuccessInformationOTC"
        v-clipboard:error="onCopyError" -->

    <!-- v-clipboard:copy="
          $t('msg.userid') +
          ': ' +
          ` ${member.uid} ` +
          $t('msg.email') +
          ': ' +
          ` ${member.email} ` +
          $t('msg.address') +
          ': ' +
          ` ${trade.targetAddress} ` +
          $t('msg.expected_amount_in') +
          ` ${trade.sourceCurrency.symbol}: ` +
          ' ' +
          trade.estimatedAmount.toFixed(6) +
          ' ' +
          $t('msg.estimated_amount_in') +
          ' BLU: ' +
          getEstimatedAmount()
        " -->
    <div class="column tal_c" v-if="details && !this.trade.sellerId">
      <div
        style="display: flex; justify-content: center; align-items: center"
        class="pointer"
        @click="purchaseInformation()"
      >
        <p class="capitalize">
          {{ $t("msg.otc_purcahse_info") }}
          <span v-html="iconSets.copy" class="icon_class_1"></span>
        </p>
      </div>
    </div>

    <div class="column tal_c m10_t">
      <button
        class="button is-success fat"
        v-if="allowPurchase"
        style="
          width: 100%;
          height: 100%;
          padding: 20px;
          border-radius: 10px;
          margin-bottom: 20px;
          display: flex;
          justify-content: space-between;
          background: #22c8b5 !important;
        "
        @click="callPayWithBalance()"
      >
        <div>{{ $t("msg.pay_with_USDT") }}</div>
        <div style="text-align: right; display: flex">
          <span
            v-html="iconSets.general_wallet_white"
            class="icon_class_1"
            style="margin-right: 10px"
          ></span>
          {{ usdtAccount.balance | decimalsCrypto(6) }}
          {{ usdtAccount.currency.symbol }} <br />
        </div>
      </button>

      <button
        v-else
        class="button is-success fat"
        style="
          width: 100%;
          height: 100%;
          padding: 20px;
          border-radius: 10px;
          margin-bottom: 10px;
          display: flex;
          justify-content: space-between;
          background: gray !important;
          cursor: not-allowed;
        "
        @mouseover="showTooltip = true"
        @mouseleave="showTooltip = false"
      >
        <div>{{ $t("msg.pay_with_USDT") }}</div>
        <div style="text-align: right; display: flex">
          <span
            v-html="iconSets.general_wallet_white"
            class="icon_class_1"
            style="margin-right: 10px"
          ></span>
          {{ usdtAccount.balance | decimalsCrypto(6) }}
          {{ usdtAccount.currency.symbol }} <br />
        </div>
      </button>

      <transition name="bounce">
        <div
          v-if="showTooltip"
          class="info"
          style="color: red; font-weight: 500; margin-bottom: 20px"
          v-html="$t('msg.minimum_purchase_USDT')"
        />
      </transition>

      <button
        v-if="cancelOrder || doneOrder"
        class="button is-info is-outlined fat"
        style="width: 100%; height: 100%; padding: 20px; border-radius: 10px"
        @click="createNewOrder()"
      >
        {{ $t("msg.create_order") }}?
      </button>

      <button
        v-if="!cancelOrder && !doneOrder && !this.trade.sellerId"
        class="button is-danger is-outlined fat"
        style="width: 100%; height: 100%; padding: 20px; border-radius: 10px"
        @click="confirmCancelPurchase()"
      >
        {{ $t("msg.cancel_transaction") }}?
      </button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Progress from "easy-circular-progress";
import moment from "moment";
import Swal from "sweetalert2";

export default {
  props: ["purchaseHome"],
  data: () => ({
    requestLoading: false,
    purchase: "",
    details: false,
    createAtPurchase: "",
    finishAtPurchase: "",
    resultPercent: "",
    trade: "",
    cancelOrder: false,
    doneOrder: false,
    qrCodeDiv: false,
    isMobile: "",
    showTooltip: false,
    timer: {
      days: "",
      hours: "",
      minutes: "",
    },
    allowPurchase: false,
    usdtPurchase: false,

    complete: {
      days: "",
      hours: "",
      minutes: "",
    },
  }),
  created() {
    this.getTradeTracking();
    setInterval(() => {
      this.getTradeTracking();
    }, 10000);
  },

  mounted() {
    window.addEventListener("resize", this.checkIfMobile);
    this.checkIfMobile();
    this.verifyBalanceToPurchase();
  },
  methods: {
    currencyFormat(num, symb) {
      if (symb == "RAS" || symb == "USDT") {
        return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      } else {
        return num.toFixed(8);
      }
    },

    checkIfMobile() {
      let w = window,
        x = w.innerWidth;

      if (x > 1200) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    },

    purchaseInformation() {
      if (this.doneOrder) {
        this.$emit("backToStart");
      } else {
        Swal.fire({
          title: this.$t("msg.otc_purcahse_info"),
          html:
            `<p style="text-align: initial; margin-top:20px;" >User ID: ${this.member.uid}</p>` +
            `<p style="text-align: initial; margin-top:20px;" >Email: ${this.member.email}</p>` +
            `<p style="text-align: initial; margin-top:20px;" >${this.$t(
              "msg.address"
            )}: ${this.purchaseHome.targetAddress}</p>` +
            `<p style="text-align: initial; margin-top:20px;" >${this.$t(
              "msg.expected_amount_in"
            )} ${this.trade.sourceCurrency.symbol}: ${this.currencyFormat(
              this.trade.estimatedAmount,
              this.trade.sourceCurrency.symbol
            )}</p>` +
            `<p style="text-align: initial; margin-top:20px;" >${this.$t(
              "msg.estimated_amount_in"
            )} BLUE: ${this.getEstimatedAmount()}</p>`,
          icon: "info",
          showCancelButton: true,
          cancelButtonColor: "#3A8CEA",
          confirmButtonColor: "#0CA2B5",
          confirmButtonText: this.$t("msg.copy"),
          cancelButtonText: this.$t("msg.back"),
        }).then(async (result) => {
          if (result.isConfirmed) {
            var text = `User ID: ${this.member.uid}, Email: ${
              this.member.email
            }, ${this.$t("msg.address")}: ${
              this.trade.targetAddress
            }, ${this.$t("msg.expected_amount_in")} ${
              this.trade.sourceCurrency.symbol
            }: ${this.currencyFormat(
              this.trade.estimatedAmount,
              this.trade.sourceCurrency.symbol
            )}, ${this.$t(
              "msg.estimated_amount_in"
            )} BLU: ${this.getEstimatedAmount()}`;
            navigator.clipboard.writeText(text);
          }
        });
      }
    },

    createNewOrder() {
      this.$emit("backToStart");
    },

    verifyBalanceToPurchase() {
      return this.usdtAccount.balance > this.bluValue[0].tradeMinimal
        ? (this.allowPurchase = true)
        : (this.allowPurchase = false);
    },

    async callPayWithBalance() {
      // let balance = this.usdtAccount.balance;
      let balance = 200;
      let send;
      if (balance > this.trade.estimatedAmount) {
        send = this.trade.estimatedAmount;
      }

      if (balance <= this.trade.estimatedAmount) {
        send = balance;
      }

      let payload = {
        tradeID: this.trade.tradeId,
        amount: send,
        addressToPay: this.purchaseHome.targetAddress,
      };

      await this.$store
        .dispatch("postPurchaseCurrencyBalance", payload)
        .then((resp) => {
          this.getTradeById(resp.data);
          if (resp.status == 200) {
            Swal.fire(
              this.$t("msg.tks_your_payment"),
              this.$t("msg.wait_create_tokens"),
              "success"
            );
            this.allowPurchase = false;
            this.usdtPurchase = true;
            
          }
        });
    },

    getEstimatedAmount() {
      if (this.purchase) {
        let fee =
          (this.trade.confirmedAmount * this.feePurchase.fee) /
          (100 + this.feePurchase.fee) /
          this.purchase.targetPrice;
        let result = this.trade.confirmedAmount / this.purchase.targetPrice;

        let result3 = result - fee;

        return result3.toFixed(6);
      } else {
        let fee =
          (this.trade.confirmedAmount * this.feePurchase.fee) /
          (100 + this.feePurchase.fee) /
          this.purchaseHome.targetPrice;
        let result = this.trade.confirmedAmount / this.purchaseHome.targetPrice;

        let result3 = result - fee;

        return result3.toFixed(6);
      }
    },

    qrCodeZoom() {
      this.qrCodeDiv = !this.qrCodeDiv;
    },

    // async checkTradeObject() {
    //   if (this.purchaseHome) {
    //     this.purchase = this.purchaseHome;
    //     this.trade = await this.$store.dispatch(
    //       "getTradeSearchByTradeId",
    //       this.purchase.id
    //     );
    //   } else {
    //     await this.getPurchases();
    //   }
    // },
    setCancelOrder() {
      this.cancelOrder = true;
    },

    async getPurchases() {
      try {
        let resp = await this.$store.dispatch("getPurchases");
        this.getTradeById(resp.data);
      } catch (e) {
        this.logError(e);
      }
    },

    async getTradeTracking() {
      if (this.purchaseHome && this.member.level == "seller") {
        let resp = await this.$store.dispatch(
          "getTradeSearchByTradeId",
          this.purchaseHome.id
        );
        this.trade = resp.data[0];
        this.checkPercetToCancelPurchase();
        this.checkStatus();
        this.checkTime();
      } else {
        try {
          let resp = await this.$store.dispatch("getTrade");
          this.trade = resp.data;
          this.purchaseHome = resp.data;
          this.checkPercetToCancelPurchase();
          this.checkStatus();
          this.checkTime();
          this.getPurchases();
        } catch (e) {
          console.log("could not load fees: ", e);
        }
      }
    },

    getTradeById(purchases) {
      for (let i in purchases) {
        if (purchases[i].id == this.trade.tradeId) {
          this.purchase = purchases[i];
          break;
        }
      }
    },

    checkTime() {
      let createAt = new Date(
        this.purchaseHome.createdAt.substring(
          0,
          this.purchaseHome.createdAt.length - 8
        )
      );

      let tempDate = new Date(
        this.purchaseHome.createdAt.substring(
          0,
          this.purchaseHome.createdAt.length - 8
        )
      );

      let createAtPurchaseExpireIn = createAt.setMilliseconds(
        this.purchaseHome.expiresIn
      );
      let finishAtPurchase = new Date(createAtPurchaseExpireIn);

      let a = moment(tempDate);
      let b = moment(finishAtPurchase);

      var diffDaysC = b.diff(a, "days");
      var diffHoursC = b.diff(a, "hours");
      var diffMinC = b.diff(a, "minutes");

      this.complete.days = diffDaysC;
      this.complete.hours = diffHoursC;
      this.complete.minutes = diffMinC;

      var today = new Date();

      var diffDays = b.diff(today, "days");
      var diffHours = b.diff(today, "hours");
      var diffMin = b.diff(today, "minutes");

      this.timer.days = diffDays;
      this.timer.hours = diffHours;
      this.timer.minutes = diffMin;

      if (diffMin < 0) {
        this.$emit("backToStart");
      }
    },

    checkPercetToCancelPurchase() {
      let tempDate = new Date(
        this.purchaseHome.createdAt.substring(
          0,
          this.purchaseHome.createdAt.length - 8
        )
      );

      let createAtPurchaseExpireIn = moment(
        tempDate.setMilliseconds(this.purchaseHome.expiresIn)
      );

      let today = new Date();

      let finishAtPurchase = new Date(createAtPurchaseExpireIn);

      let c = moment(today);
      let b = moment(finishAtPurchase);
      var diffDays = b.diff(c);
      this.resultPercent =
        ((this.purchaseHome.expiresIn - diffDays) /
          this.purchaseHome.expiresIn) *
        100;
    },

    getHours(teste) {
      var n = teste;
      var num = n;
      var hours = num / 60;
      var rhours = Math.floor(hours);
      var minutes = (hours - rhours) * 60;
      var rminutes = Math.round(minutes);

      if (teste > 60) {
        return rhours > 1
          ? rhours + " Hs " + rminutes + " Min"
          : rhours + " H " + rminutes + " Min";
      } else {
        return teste + " Min";
      }
    },

    confirmCancelPurchase() {
      if (this.doneOrder) {
        this.$emit("backToStart");
      } else {
        Swal.fire({
          title: this.$t("msg.attention"),
          html:
            `<p style="text-align: initial; margin-top:20px;" >${this.$t(
              "msg.you_want_start_new_purchase"
            )}</p>` +
            `<p style="text-align: initial; margin-top:20px; margin-bottom:80px">${this.$t(
              "msg.do_you_want"
            )}</p>`,
          icon: "warning",
          showCancelButton: true,
          cancelButtonColor: "#3A8CEA",
          confirmButtonColor: "#FF5050",
          confirmButtonText: this.$t("msg.yes_cancel_purchase"),
          cancelButtonText: this.$t("msg.back"),
        }).then(async (result) => {
          if (!this.requestLoading) {
            if (result.isConfirmed) {
              this.requestLoading = true;
              if (
                this.trade.status == "new" ||
                this.trade.status == "waiting"
              ) {
                let result = await this.$store.dispatch(
                  "putPurchaseCancel",
                  this.trade.tradeId
                );
                if (result.status == 200) {
                  this.getTradeTracking();
                } else {
                  alert("Something wrong");
                  console.log(result);
                }
              }
              this.requestLoading = false;
            }
          }
        });
      }
    },

    checkStatus() {
      if (this.trade.status) {
        if (
          this.trade.status == "cancelled" ||
          this.trade.status == "expired"
        ) {
          this.cancelOrder = true;
        }

        if (this.trade.status == "done") {
          this.doneOrder = true;
          this.$store.dispatch("updateUsdtAccount");
        }
      }
    },
  },

  components: {
    Progress,
  },

  computed: {
    ...mapGetters([
      "btcValue",
      "usdtAccount",
      "bluValue",
      "ethValue",
      "member",
      "feePurchase",
      "ethAccount",
      "currencies",
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/private/landing/base_buy_blu/steps/BluWatchStep1.vue